import AcUnitIcon from '@mui/icons-material/AcUnit';
import CloseIcon from '@mui/icons-material/Close';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Slide from '@mui/material/Slide';
import { useTheme } from "@mui/material/styles";
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';
import Typography from '@mui/material/Typography';
import useMediaQuery from "@mui/material/useMediaQuery";
import _ from "lodash";
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { PrintEtat } from '../ApplisMobile/Enseignant/Etat/print';
import Urne from '../ApplisMobile/Enseignant/Urne';
import { IOptionChoisie } from '../ApplisMobile/Souscription';
import { IReduxState } from '../store';
import { setGoToTirage } from '../store/appSlice';
import { IEnseignantItem, IEnseignantPourTirage, addArrayGagnantToPrint, 
    setArrayGagnantToPrint, setChoising, 
    setEnseignants } from '../store/focusEcoleSlice';
import { colorProfExpert } from '../util/constant';
import { getPrecedentMois } from '../util/functions';


export const currentYear = {
    annee: new Date().getFullYear().toString(),
}


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const Tirage = () => {

    //redux
    const dispatch = useDispatch()
    const goToTirage = useSelector((state: IReduxState) => state.application.goToTirage);
    const choising = useSelector((state: IReduxState) => state.focusEcole.choising);
    const enseignants = useSelector((state: IReduxState) => state.focusEcole.enseignants);
    console.log("🚀 ~ Tirage ~ enseignants++++++:", enseignants)
    const arrayGagnantToPrint = useSelector((state: IReduxState) => {
        console.log("🚀 ~ Tirage ~ arrayGagnantToPrint:", state.focusEcole.arrayGagnantToPrint)
        return state.focusEcole.arrayGagnantToPrint;            
    });

    //hooks
    const [winner, setWinner] = useState<IEnseignantItem | undefined>()
    const theme = useTheme();
    const lgDown = useMediaQuery(theme.breakpoints.down("lg"));
    const [compteur, setCompteur] = useState(0)
    const [optionState, setOptionState] = useState<IOptionChoisie>({ optionChoisie: "mensuel" })

    const handleInputChange = (e: any) => {
        const { value, name } = e.target
        setOptionState({ ...optionState, [name]: value })
    }


    const handleClose = () => {
        dispatch(setGoToTirage(!goToTirage))
    };

    //Change l'ordre des éléments dans le tableau d'objets
    const trierParIdPersonnel = (data: any) => {
        //Retirer les professeurs qui ont été déjà tirés du tableau enseignants
        const enseignantsRestants: any = _.differenceBy(data, arrayGagnantToPrint, 'idPersonnel');
        let newArray = [...enseignantsRestants]
        return newArray?.sort((a, b) => {
            const indexAleatoire = Math.floor(Math.random() * newArray.length);
            const enseignantTrouveAuHazard = newArray[indexAleatoire];
            // Si a et b ont la propriété 'idPersonnel', triez par 'idPersonnel'
            if ('idPersonnel' in a && 'idPersonnel' in b) {
                return a.idPersonnel - enseignantTrouveAuHazard.idPersonnel;
            }
            // Si les types ne correspondent pas ou s'ils n'ont pas la propriété 'idPersonnel', ne modifiez pas l'ordre
            return 0;
        });
    };


    // function tirageAuSortEtRetirer(tableau) {
    //     // Générer un index aléatoire
    //     const indexAleatoire = Math.floor(Math.random() * tableau.length);
    //     // Sélectionner le gagnant
    //     const gagnant = tableau[indexAleatoire];
    //     // Retirer le gagnant du tableau avec Lodash
    //     const resteParticipants = _.reject(tableau, { id: gagnant.id });
    //     // Retourner le gagnant et le tableau mis à jour
    //     return { gagnant, resteParticipants };
    //   }

    const tirageMensuel = async (data: IEnseignantPourTirage[]) => {
        let resteParticipants: IEnseignantPourTirage[] = []
        dispatch(setChoising(true));
        setWinner(undefined)
        const choixAleatoire = new Promise((resolve) => {
            // Simuler une attente avec setTimeout pour imiter une opération asynchrone
            setTimeout(() => {
                // Générer un index aléatoire dans le tableau des enseignants
                const indexAleatoire = Math.floor(Math.random() * data.length);
                // Récupérer l'enseignant à l'index aléatoire
                const gagnant = data[indexAleatoire];
                //Retirer le gagnant du tableau avec Lodash
                resteParticipants = _.reject(data, { numeroCellulaire: gagnant.numeroCellulaire });
                resolve(gagnant);
            }, 5000); // Temps d'attente simulé de 5 seconde
        });
        choixAleatoire.then((gagnant: any) => {
            const newObjet = { ...gagnant, numOrdre: obtenirValeurMensuelleSelonIndex() }
            dispatch(setEnseignants(resteParticipants));
            dispatch(addArrayGagnantToPrint(newObjet));
            setWinner(gagnant)
            dispatch(setChoising(false));
        });
    };


    const tirageAnnuel = async (data: any) => {
        // console.log("🚀 ~ tirageAnnuel ~ data:", data)
        dispatch(setChoising(true));
        setCompteur(compteur + 1)
        let gagnant: any;
        setWinner(undefined)
        // const newOrdreEnseignants = _.orderBy(enseignants, ['nb'], ['asc']).slice(0,3)
        const choixAleatoire = new Promise((resolve) => {
            // Simuler une attente avec setTimeout pour imiter une opération asynchrone
            setTimeout(() => {
                switch (compteur) {
                    case 0:
                        gagnant = data[2];
                        break;
                    case 1:
                        gagnant = data[1];
                        break;
                    case 2:
                        gagnant = data[0];
                        break;
                    default:
                        break;
                }
                resolve(gagnant);
            }, 5000); // Temps d'attente simulé de 5 seconde
        });
        choixAleatoire.then((gagnant: any) => {
            const newObjet = { ...gagnant, numOrdre: obtenirValeurAnnuelleSelonIndex() }
            dispatch(addArrayGagnantToPrint(newObjet));
            setWinner(gagnant)
            dispatch(setChoising(false));
        });
    };

    const handleTirage = () => {
        //Prendre les 3 premiers utilisateurs du tableau quand il s'agit du tirage annuel
        const troisPremierEnseignant = enseignants.slice(0, 3);
        //Prendre tous les enseignants utilisateur de prof-expert quand il s'agit du tirage mensuel ou  les 3 premiers quand il s'agit du tirage annuel
        return optionState.optionChoisie === "mensuel"
            ? tirageMensuel(enseignants)
            : tirageAnnuel(troisPremierEnseignant)

    }

    const handleResetWinnersList = () => {
        dispatch(setArrayGagnantToPrint([]));
        setCompteur(0)
        window.location.reload();
    };

    const obtenirValeurMensuelleSelonIndex = () => {
        if (arrayGagnantToPrint.length === 0) {
            return 5;
        } else if (arrayGagnantToPrint.length === 1) {
            return 4;
        } else if (arrayGagnantToPrint.length === 2) {
            return 3;
        } else if (arrayGagnantToPrint.length === 3) {
            return 2;
        } else if (arrayGagnantToPrint.length === 4) {
            return 1;
        } else {
            return -1; // Valeur par défaut si les conditions ne sont pas remplies
        }
    }

    const obtenirValeurAnnuelleSelonIndex = () => {
        if (arrayGagnantToPrint.length === 0) {
            return 3;
        } else if (arrayGagnantToPrint.length === 1) {
            return 2;
        } else if (arrayGagnantToPrint.length === 2) {
            return 1;
        } else {
            return -1; // Valeur par défaut si les conditions ne sont pas remplies
        }
    }

    return (
        <React.Fragment>
            <Dialog
                fullScreen
                open={goToTirage}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', background: colorProfExpert }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleResetWinnersList}
                            aria-label="close"
                        >
                            <EmojiEventsIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {`Tombola Prof-Expert: ${optionState.optionChoisie === "mensuel"
                                ? `Tirage du mois ${getPrecedentMois()}`
                                : "Le dernier tirage de"} ${2026}`}
                                {/* : "Le dernier tirage de"} l'année ${currentYear.annee}`} */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>


                <Box style={{ marginLeft: 10 }}>
                    <FormControl>
                        <RadioGroup
                            row
                            name="optionChoisie"
                            onChange={handleInputChange}
                        >
                            <FormControlLabel value="mensuel" checked={optionState.optionChoisie === "mensuel" ? true : false} control={<Radio color="warning" />} style={{ color: "gray" }} label="Mensuel" />
                            <FormControlLabel value="annuel" checked={optionState.optionChoisie === "annuel" ? true : false} control={<Radio color="warning" />} style={{ color: "gray" }} label="Annuel" />
                        </RadioGroup>
                    </FormControl>
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        maxWidth: '1000px',
                        // p: 1,
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        marginTop: lgDown ? "20px" : ""
                    }}
                >
                    {enseignants.length
                        ? <Grid container spacing={2}>
                            <Grid item xs={12} md={6} sm={6} lg={6} style={{ background: "" }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12} sm={12} lg={12}>
                                        {arrayGagnantToPrint.length
                                            ? arrayGagnantToPrint.map((item, i: number) => (
                                                <Box
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        background: "gray",
                                                        color: "#ffffff",
                                                        // background: "lightGray",
                                                        border: arrayGagnantToPrint.length === (optionState.optionChoisie === "mensuel" ? 5 : 3) && i === 0 ? `5px dashed gold` : "",
                                                        padding: 10,
                                                        margin: 10,
                                                        borderRadius: 10,
                                                        width: "100%"
                                                    }}
                                                    key={i}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography variant="body1">
                                                                    {`${item?.nomPersonnel} ${item?.prenomPersonnel} - ${item?.phone1 ? item?.phone1 : item?.phone2}`}
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    style={{ fontWeight: "lighter" }}
                                                                >
                                                                    {`${item?.numOrdre === 1 ? "Super gagnant" : `${item?.numOrdre}e`}`}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box style={{ display: "flex", flexDirection: "column", color: "#ffffff" }}>
                                                                <Typography variant="caption">
                                                                    {`${item?.libelleMatiereLong}`}
                                                                </Typography>
                                                                <Typography variant="caption">
                                                                    {
                                                                        `${item?.codeEtab} - ${item?.libelleEtab} - ${item?.anneeScolaire}`
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />
                                                </Box>
                                            ))

                                            : <img
                                                src={"/img/Frame2_1.png"}
                                                style={{ width: "100%", height: "auto", borderRadius: 10 }}
                                            />
                                        }
                                    </Grid>

                                    <Grid item xs={12} md={12} sm={12} lg={12}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            background: ""
                                        }}
                                    >
                                        {/* {arrayGagnantToPrint.length === (optionState.optionChoisie === "mensuel" ? 5 : 3) && <PrintEtat />} */}
                                        {arrayGagnantToPrint.length === (optionState.optionChoisie === "mensuel" ? 5 : 3) && ""}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6} sm={6} lg={6} style={{ background: "" }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12} sm={12} lg={12}>
                                        <Urne winner={winner} />
                                    </Grid>

                                    <Grid item xs={12} md={12} sm={12} lg={12}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <LoadingButton
                                            loadingPosition="end"
                                            loading={choising}
                                            endIcon={<AcUnitIcon />}
                                            size="small"
                                            variant="contained"
                                            // color='success'
                                            style={{ background: arrayGagnantToPrint.length === (optionState.optionChoisie === "mensuel" ? 5 : 3) ? "#d3d3d3" : colorProfExpert, color: "white" }}
                                            onClick={handleTirage}
                                            disabled={arrayGagnantToPrint.length === (optionState.optionChoisie === "mensuel" ? 5 : 3)}
                                        >
                                            Effectuer le tirage
                                        </LoadingButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        : "Chargement des données..."
                    }

                </Box>
            </Dialog>
        </React.Fragment>
    );
}
